module.exports = __webpack_public_path__ + "img/credit_dan.a2d2cf89.png";